import axios from 'axios';
import Vue from 'vue';
import stores from '@/stores';
import router from '@/router';
import jError from '@/error/jError';
import { Base64 } from 'js-base64';

export default {
  generateApi(baseURL = process.env.GATE_URL) {
    const token = Vue.ls.get('Token');

    const api = axios.create({
      baseURL,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    api.interceptors.response.use(
      (response) => {
        if (typeof response.headers.token !== 'undefined') {
          stores.commit('jStoreLogin/saveToken', response.headers);
          stores.commit('jStoreLogin/setInLocalStorage');
        }
        return response;
      },
      (error) => {
        if (typeof error.response.data.session_expired === 'boolean') {
          if (error.response.data.session_expired === true) {
            router.push('/logout');
          }
        } else if (error.response.status === 406 || error.response.status === 401) {
          router.push('/logout');
        } else if (error.response.status === 400) {
          stores.dispatch('jStoreNotificationScreen/toggleProblem', error.response.data.message, { root: true });
        } else if (error.response.status === 422) {
          stores.dispatch('jStoreNotificationScreen/toggleProblem', error.response.data.message, { root: true });
        }
        jError.getErrorMessage(error.response.data);
        // handle error
        return Promise.reject(error);
      });

    return api;
  },
  generateApiPublic() {
    // const username = 'default_user';
    // const password = 'default_password';

    // const api = axios.create({
    //   baseURL: process.env.GATE_URL,
    //   headers: {
    //     Authorization: `Basic ${Base64.encode(`${username}:${password}`)}`,
    //     'Content-Type': 'application/json',
    //   },
    // });

    const token = Vue.ls.get('Token');

    const api = axios.create({
      baseURL: process.env.GATE_URL,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    api.interceptors.response.use(
      (response) => {
        if (typeof response.headers.token !== 'undefined') {
          stores.commit('jStoreLogin/saveToken', response.headers);
          stores.commit('jStoreLogin/setInLocalStorage');
        }
        return response;
      },
      (error) => {
        if (typeof error.response.data.session_expired === 'boolean') {
          if (error.response.data.session_expired === true) {
            router.push('/logout');
          }
        } else if (error.response.status === 406 || error.response.status === 401) {
          router.push('/logout');
        }
        jError.getErrorMessage(error.response.data);
        // handle error
        return Promise.reject(error);
      });

    return api;
  },
  loginApi() {
    const config = {
      baseURL: process.env.GATE_URL,
      headers: {},
    };
    if (Number(process.env.IS_COMPANY_GEN_TYPE_FLAGGING) === 1) {
      config.headers['X-VERSION'] = 1;
    }

    const api = axios.create(config);
    return api;
  },
  refreshTokenApi() {
    const api = axios.create({
      baseURL: process.env.GATE_URL,
    });
    api.interceptors.response.use(
      response => response,
      (error) => {
        if (error.response.status === 406 || error.response.status === 401) {
          router.push('/logout');
        }
        return Promise.reject(error);
      });
    return api;
  },
  generateApiMock() {
    const api = axios.create({
      baseURL: 'http://mockapi.jojonomic.io/api/',
    });
    return api;
  },
  generateJojoChatApi() {
    // const token = Vue.ls.get('Token');

    const api = axios.create({
      baseURL: 'https://chat.jojonomic.com/',
      headers: {
        'X-Auth-Token': 'CTamaUhJOQl1vqm2vK-u2k5gCEO9di_GBmHYhTrz9PP',
        'X-User-Id': 'Lc9baWX9kNSSvKbkM',
      },
    });

    api.interceptors.response.use(
      (response) => {
        if (typeof response.headers.token !== 'undefined') {
          stores.commit('jStoreLogin/saveToken', response.headers);
          stores.commit('jStoreLogin/setInLocalStorage');
        }
        return response;
      },
      (error) => {
        if (typeof error.response.data.session_expired === 'boolean') {
          if (error.response.data.session_expired === true) {
            router.push('/logout');
          }
        } else if (error.response.status === 406 || error.response.status === 401) {
          router.push('/logout');
        }
        jError.getErrorMessage(error.response.data);
        // handle error
        return Promise.reject(error);
      });

    return api;
  },
  generateJojolinkApi() {
    const token = Vue.ls.get('Token');

    const api = axios.create({
      baseURL: 'https://jojonomic.jojolink.io',
      headers: {
        Authorization: `Bearer ${token}`,
        'Access-Control-Allow-Origin': 'https://jojonomic.jojolink.io',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Headers': "'Access-Control-Allow-Headers: Origin, Content-Type, X-Auth-Token'",
      },
    });

    api.interceptors.response.use(
      (response) => {
        if (typeof response.headers.token !== 'undefined') {
          stores.commit('jStoreLogin/saveToken', response.headers);
          stores.commit('jStoreLogin/setInLocalStorage');
        }
        return response;
      },
      (error) => {
        if (typeof error.response.data.session_expired === 'boolean') {
          if (error.response.data.session_expired === true) {
            router.push('/logout');
          }
        } else if (error.response.status === 406 || error.response.status === 401) {
          router.push('/logout');
        } else if (error.response.status === 400) {
          stores.dispatch('jStoreNotificationScreen/toggleProblem', error.response.data.message, { root: true });
        }
        jError.getErrorMessage(error.response.data);
        // handle error
        return Promise.reject(error);
      });

    return api;
  },
  generateBasicAuthApi() {
    const username = 'default_user';
    const password = 'default_password';

    const api = axios.create({
      baseURL: process.env.GATE_URL,
      headers: {
        Authorization: `Basic ${Base64.encode(`${username}:${password}`)}`,
        'Content-Type': 'application/json',
      },
    });

    api.interceptors.response.use(
      (response) => {
        if (typeof response.headers.token !== 'undefined') {
          stores.commit('jStoreLogin/saveToken', response.headers);
          stores.commit('jStoreLogin/setInLocalStorage');
        }
        return response;
      },
      (error) => {
        if (typeof error.response.data.session_expired === 'boolean') {
          if (error.response.data.session_expired === true) {
            router.push('/logout');
          }
        } else if (error.response.status === 406 || error.response.status === 401) {
          router.push('/logout');
        }
        jError.getErrorMessage(error.response.data);
        // handle error
        return Promise.reject(error);
      });

    return api;
  },
};



// WEBPACK FOOTER //
// ./src/services/jApi.js